import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppService } from '@app/app.service';
import { IAppBreadcrumbs } from '@app/layout/breadcrumbs/interfaces/app-breadcrumbs.interface';
import { AppBreadcrumbsService } from '@app/layout/breadcrumbs/services/app-breadcrumbs.service';
import { map } from 'rxjs/operators';

/**
 * Навигационная цепочка разделов приложения в одну строку.
 * Сохраняет ширину подписей из словаря интерфейса и сокращает остальные названия с подсказкой полного текста.
 */
@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['../styles/breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent {
    public readonly appService = inject(AppService);
    public readonly service = inject(AppBreadcrumbsService);

    /** Словарные подписи остаются фиксированными; названия объектов сжимаются с многоточием. */
    readonly breadcrumbs$ = this.service.breadcrumbsList$.pipe(
        map((items) => {
            const systemNames = new Set(Object.values(this.appService.language_dictionary ?? {}));
            return items.map((item) => ({ ...item, isDynamic: !systemNames.has(item.name) }));
        }),
    );

    /**
     * TrackBy для перебора хлебных крошек
     * @param item - элемент хлебных крошек
     */
    public readonly trackByLink = (_index: number, item: IAppBreadcrumbs): string | null => item.link;
}
